import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
export default (InnerComponent => {
  // eslint-disable-next-line @repo/internal/react/no-class-components
  class EngagementEventsWrapper extends Component {
    constructor(...args) {
      super(...args);
      _defineProperty(this, "fireClickEvent", clickType => {
        this.fireEvent('click', {
          clickType
        });
      });
    }
    UNSAFE_componentWillMount() {
      this.fireEvent('shown');
    }
    componentWillUnmount() {
      this.fireEvent('hidden');
    }
    fireEvent(action, properties = {}) {
      const {
        createAnalyticsEvent,
        messageId,
        variationId,
        componentId,
        componentType,
        isLast
      } = this.props;
      const analyticsEvent = createAnalyticsEvent({
        action,
        ...properties
      });
      analyticsEvent.update({
        ekMessageId: messageId,
        ekVariationId: variationId,
        ekComponentId: componentId,
        ekComponentType: componentType,
        ekIsLast: isLast
      });
      analyticsEvent.fire('engagement');
    }
    render() {
      return /*#__PURE__*/React.createElement(InnerComponent, _extends({}, this.props, {
        fireClickEvent: this.fireClickEvent
      }));
    }
  }
  return withAnalyticsEvents()(EngagementEventsWrapper);
});